module.exports = __webpack_public_path__ + "images/115_640.jpg";